import * as actionTypes from 'manage-modules/redux/manageModulesActionTypes';
import uuid from 'uuid';

export const applyFilterQuery = filterQuery => ({
  type: actionTypes.APPLY_FILTER_QUERY,
  filterQuery,
});
export const changeModuleCardField = (field, value) => ({
  type: actionTypes.CHANGE_MODULE_CARD_FIELD,
  field,
  value,
});
export const changeNewModuleCardThumbnail = file => ({
  type: actionTypes.CHANGE_NEW_MODULE_CARD_THUMBNAIL,
  file,
});
export const fetchModules = () => ({ type: actionTypes.FETCH_MODULES });
export const filterQueryChanged = filterQuery => ({
  type: actionTypes.FILTER_QUERY_CHANGED,
  filterQuery,
});
export const hideDiscardNewModuleConfirmationDialog = () => ({
  type: actionTypes.HIDE_DISCARD_NEW_MODULE_CONFIRMATION_DIALOG,
});
export const hideRemoveModuleItemsConfirmationDialog = () => ({
  type: actionTypes.HIDE_REMOVE_MODULE_ITEMS_CONFIRMATION_DIALOG,
});
export const moduleFieldSynced = (moduleId, field, value) => ({
  type: actionTypes.MODULE_FIELD_SYNCED,
  moduleId,
  field,
  value,
});
export const moduleItemsLoaded = items => ({
  type: actionTypes.MODULE_ITEMS_LOADED,
  items,
});
export const moduleItemsSynced = () => ({
  type: actionTypes.MODULE_ITEMS_SYNCED,
});
export const moduleThumbnailSynced = moduleId => ({
  type: actionTypes.MODULE_THUMBNAIL_SYNCED,
  moduleId,
});
export const modulesLoaded = modules => ({
  type: actionTypes.MODULES_LOADED,
  modules,
});
export const newModule = () => ({ type: actionTypes.NEW_MODULE });
export const newModuleCardInternalCodeSuggested = suggestedInternalCode => ({
  type: actionTypes.NEW_MODULE_CARD_INTERNAL_CODE_SUGGESTED,
  suggestedInternalCode,
});
export const newModulePublished = moduleId => ({
  type: actionTypes.NEW_MODULE_PUBLISHED,
  moduleId,
});
export const publishNewModule = thumbnailFile => ({
  type: actionTypes.PUBLISH_NEW_MODULE,
  id: uuid.v4(),
  thumbnailFile,
});
export const removeModuleCardItems = () => ({
  type: actionTypes.REMOVE_MODULE_CARD_ITEMS,
});
export const saveNewModuleCardField = (field, value) => ({
  type: actionTypes.SAVE_NEW_MODULE_CARD_FIELD,
  field,
  value,
});
export const saveNewModuleCardFieldSuggestAsInternalCode = (field, value) => ({
  type: actionTypes.SAVE_NEW_MODULE_CARD_FIELD_SUGGEST_AS_INTERNAL_CODE,
  field,
  value,
});
export const selectAllModuleItems = selected => ({
  type: actionTypes.SELECT_ALL_MODULE_ITEMS,
  selected,
});
export const selectModule = moduleId => ({
  type: actionTypes.SELECT_MODULE,
  moduleId,
});
export const selectModuleItem = (selected, mediaId) => ({
  type: actionTypes.SELECT_MODULE_ITEM,
  selected,
  mediaId,
});
export const showDiscardNewModuleConfirmationDialog = () => ({
  type: actionTypes.SHOW_DISCARD_NEW_MODULE_CONFIRMATION_DIALOG,
});
export const showEditModuleCardThumbnail = show => ({
  type: actionTypes.SHOW_EDIT_MODULE_CARD_THUMBNAIL,
  show,
});
export const showModuleThumbnailUrl = (moduleId, url) => ({
  type: actionTypes.SHOW_MODULE_THUMBNAIL_URL,
  moduleId,
  url,
});
export const showNewModuleThumbnailUrl = url => ({
  type: actionTypes.SHOW_NEW_MODULE_THUMBNAIL_URL,
  url,
});
export const showMoreModules = () => ({ type: actionTypes.SHOW_MORE_MODULES });
export const showRemoveModuleItemsConfirmationDialog = () => ({
  type: actionTypes.SHOW_REMOVE_MODULE_ITEMS_CONFIRMATION_DIALOG,
});
export const syncModuleCardField = (field, value) => ({
  type: actionTypes.SYNC_MODULE_CARD_FIELD,
  field,
  value,
});
export const syncModuleCardInternalCode = internalCode => ({
  type: actionTypes.SYNC_MODULE_CARD_INTERNAL_CODE,
  internalCode,
});
export const syncModuleCardThumbnail = file => ({
  type: actionTypes.SYNC_MODULE_CARD_THUMBNAIL,
  file,
});
export const tabChanged = index => ({ type: actionTypes.TAB_CHANGED, index });
